import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import styles from "./styles.module.scss";
const TextAreaInput = (props) => {
    const handleChange = (e) => {
        props.setValue(e.currentTarget.value.slice(0, props.maxLength || 200));
    };
    return (_jsx("div", { className: `${styles[props.extraClassName || ""]} ${styles.textarea_container}`, children: _jsx("textarea", { value: props.value, maxLength: props.maxLength, onChange: handleChange, rows: props.rows || 15, placeholder: props.placeholder }) }));
};
export default memo(TextAreaInput);
TextAreaInput.defaultProps = {
    maxLength: 0,
    placeholder: "",
    extraClassName: "",
    rows: 15,
};
